// URL GET 获取值
export function getUrlQuery (name, Url) {
  var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
  var url = Url || location.href
  if (reg.test(url)) { return unescape(RegExp.$2.replace(/\+/g, ' ')) }
  return ''
}
